import { Injectable, Injector } from "@angular/core";
import { FormDialogTemplate } from "../../../../shared/form-dialog/form-dialog.template";
import { FormBuilder, FormGroup } from "@angular/forms";
import { BehaviorSubject } from "rxjs";
import { CtwrPartService, CtwrLocationService, CtwrPartTypeService, CtwrProgramService, CtwrProcessService, CtwrPartFamilyService } from "../../ctwr.service";

import { RequestService } from "../request.service";
import { PartsGrid } from "./part-grid.component";

@Injectable()
export class PartSearchComponent {
    formDialog: FormDialogTemplate;
    editForm: FormGroup;
    editDataItem: any;
    dialogTitle: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
    partsGrid: PartsGrid;
    selectedPart: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private readonly formBuilder: FormBuilder;
    public readonly partsService: CtwrPartService;
    public readonly programService: CtwrProgramService;
    public readonly locationService: CtwrLocationService;
    public readonly partTypeService: CtwrPartTypeService;
    public readonly processService: CtwrProcessService;
    public readonly partFamilyService: CtwrPartFamilyService;
    private readonly requestService: RequestService;

    constructor(private readonly injector: Injector) {
        this.formBuilder = injector.get(FormBuilder);
        this.partsService = injector.get(CtwrPartService);
        this.programService = injector.get(CtwrProgramService);
        this.locationService = injector.get(CtwrLocationService);
        this.partTypeService = injector.get(CtwrPartTypeService);
        this.processService = injector.get(CtwrProcessService);
        this.partFamilyService = injector.get(CtwrPartFamilyService);
        this.requestService = injector.get(RequestService);
        this.editForm = this.formBuilder.group({
            PartNumber: [],
            ProgramId: [],
            LocationId: [],
            PartTypeId: [],
            ProcessId: [],
            PartFamilyId: [],
            PartIds: [],
        })
        this.partsGrid = new PartsGrid(this.formBuilder, this.partsService);

        this.formDialog = new FormDialogTemplate();
        this.formDialog.initilize(this.dialogTitle, this.editForm, this.getFormDialogTabs());
        this.formDialog.setHeight(640);
        this.formDialog.largeForm = true;
        this.formDialog.save = this.onSave;
        this.formDialog.cancel = this.closeDialog;

        this.dialogTitle.next('Advanced Part Search');

        this.partsService.read();
        this.programService.read();
        this.locationService.read();
        this.partTypeService.read();
        this.processService.read();
        this.partFamilyService.read();

        this.editForm.valueChanges
            .subscribe(x => {
                this.partsGrid.filter.next(x);
            })
    }


    handleSearch = () => {
        this.editDataItem = {};
        this.formDialog.next(this.editDataItem);
        this.requestService.openDialog(this.formDialog);
        return this.selectedPart;
    }

    onSave = ({ dataItem, isNew }) => {
        this.closeDialog();
        this.selectedPart.next(this.partsGrid.selectedPart);
    }

    closeDialog = () => this.requestService.closeDialog();


    getFormDialogTabs() {
        return [
            {
                title: "Search",
                selected: true,
                formControls: [
                    {
                        type: 'combobox',
                        title: 'Program',
                        name: 'ProgramId',
                        textField: 'Name',
                        valueField: 'Id',
                        service: this.programService,
                    },
                    {
                        type: 'combobox',
                        title: 'Location',
                        name: 'LocationId',
                        textField: 'Name',
                        valueField: 'Id',
                        service: this.locationService,
                    },
                    {
                        type: 'combobox',
                        title: 'Part Type',
                        name: 'PartTypeId',
                        textField: 'Name',
                        valueField: 'Id',
                        service: this.partTypeService,
                    },
                    {
                        type: 'combobox',
                        title: 'Process',
                        name: 'ProcessId',
                        textField: 'Name',
                        valueField: 'Id',
                        service: this.processService,
                    },
                    {
                        type: 'combobox',
                        title: 'PartFamily',
                        name: 'PartFamilyId',
                        textField: 'Name',
                        valueField: 'Id',
                        service: this.partFamilyService,
                    },
                    {
                        type: 'text',
                        title: 'Part Number',
                        name: 'PartNumber',
                    },
                    {
                        type: 'data-grid',
                        title: 'Parts',
                        name: 'PartIds',
                        stretch: true,
                        template: this.partsGrid
                    }

                ]
            },

        ];
    }

}
